import React from 'react';
import TrendChart from '../trendChart/TrendChart';
import { Box } from '@mui/material';



const TrendCharts = ({ chartData = {}, chartLayout = 'row' }) => {
  return (
    <Box sx={{ display: "flex", flexDirection: chartLayout === "row" ? "row" : "column", position: "relative", height: "100%" }}>
      {chartData && Object.keys(chartData).length > 0 ?
        Object.keys(chartData).map((key, index) => (
          chartData[key].length > 0 && (
            <TrendChart
              key={index}
              chartData={chartData[key]}
              chartIndex={key}
              chartLayout={chartLayout}
            />
          )
        )) : <p style={{ color: "white" }}>Select a value from the list on the left and a time window with the buttons on the bottom</p>
      }
    </Box>
  );
};

export default TrendCharts;
